import PostJobs from "../../components/postJobs/PostJobs"

function PostJobsPage() {
    return (
        <>
        <PostJobs/>
        </>
    )
}
export default PostJobsPage